import { DEFAULT_HEADERS } from '@/services/constants.service';
import http from '@/services/http';

export const startOnboarding = (url, captcha_token, session_id = null) => {
    const payload = {
        url,
        captcha_token
    };

    // Add session_id to payload if provided
    if (session_id) {
        payload.session_id = session_id;
    }

    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding', payload, {
        headers: DEFAULT_HEADERS
    })
}

export const claimOnboarding = (email, user_id, marketing_consent, { suppressGlobalError = false } = {}) => {
    const payload = { email, user_id, contact_consent: marketing_consent };
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/claim', payload, {
        headers: DEFAULT_HEADERS,
        _suppressGlobalError: suppressGlobalError,
    })
}

export const claimOnboardingNoWebsite = (captcha_token, session_id = null) => {
    const payload = {
        captcha_token
    };

    // Add session_id to payload if provided
    if (session_id) {
        payload.session_id = session_id;
    }

    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/no-website', payload, {
        headers: DEFAULT_HEADERS
    })
}

export const verifyOnboarding = (user_id, verification_code, new_password, role, url, marketing_consent, utmParams = {}, cello_ucc = null, agent_name = null, brand_color = null, { suppressGlobalError = false } = {}) => {
    const payload = {
        user_id,
        verification_code,
        new_password,
        company_role: role?.id || role, // Send role.id if role is an object, otherwise send role as-is
        url: url,
        contact_consent: marketing_consent,
        utm_source: utmParams.utm_source || null,
        utm_medium: utmParams.utm_medium || null,
        utm_campaign: utmParams.utm_campaign || null,
        utm_content: utmParams.utm_content || null,
        utm_term: utmParams.utm_term || null,
        utm_adgroup: utmParams.utm_adgroup || null,
        utm_asset: utmParams.utm_asset || null,
        utm_headline: utmParams.utm_headline || null,
        utm_matchtype: utmParams.utm_matchtype || null,
        utm_device: utmParams.utm_device || null,
        utm_placement: utmParams.utm_placement || null,
        utm_adposition: utmParams.utm_adposition || null
    };
    if (cello_ucc) {
        payload.cello_ucc = cello_ucc;
    }
    if (agent_name != null) payload.agent_name = agent_name;
    if (brand_color != null) payload.brand_color = brand_color;
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/verify',
    payload, {
        headers: DEFAULT_HEADERS,
        _suppressGlobalError: suppressGlobalError,
    })
}

export const verifyOnboardingWithGoogle = ({user_id, access_token, url, role, marketing_consent, utmParams = {}, ucc, agent_name = null, brand_color = null, session_id = null, suppressGlobalError = false}) => {
    const payload = {
        user_id,
        access_token: access_token,
        company_role: role?.id || role, // Send role.id if role is an object, otherwise send role as-is
        url: url,
        contact_consent: marketing_consent,
        cello_ucc: ucc,
        utm_source: utmParams.utm_source || null,
        utm_medium: utmParams.utm_medium || null,
        utm_campaign: utmParams.utm_campaign || null,
        utm_content: utmParams.utm_content || null,
        utm_term: utmParams.utm_term || null,
        utm_adgroup: utmParams.utm_adgroup || null,
        utm_asset: utmParams.utm_asset || null,
        utm_headline: utmParams.utm_headline || null,
        utm_matchtype: utmParams.utm_matchtype || null,
        utm_device: utmParams.utm_device || null,
        utm_placement: utmParams.utm_placement || null,
        utm_adposition: utmParams.utm_adposition || null
    };
    if (agent_name != null) payload.agent_name = agent_name;
    if (brand_color != null) payload.brand_color = brand_color;
    if (session_id) payload.session_id = session_id;
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/google', payload, {
        headers: DEFAULT_HEADERS,
        _suppressGlobalError: suppressGlobalError,
    })
}

export const setChatbotPayload = (kb_id, agent_name, brand_color) => {
    return http.post(import.meta.env.VITE_APP_BASE_API + `knowledge-bases/v2/onboarding/${kb_id}/set-chatbot-payload`, {
        agent_name,
        brand_color
    }, {
        headers: DEFAULT_HEADERS
    })
}

export const confirmUrl = (url, session_id = null, bucketeer_anonymous_id = null) => {
    const payload = {
        url
    };

    // Add session_id to payload if provided
    if (session_id) {
        payload.session_id = session_id;
    }
    if (bucketeer_anonymous_id) {
        payload.bucketeer_anonymous_id = bucketeer_anonymous_id;
    }

    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/confirm-url', payload, {
        headers: DEFAULT_HEADERS,
        _suppressGlobalError: true,
    })
}

export const sendMagicLink = (email, contact_consent, session_id = null, { suppressGlobalError = false, from_demo_account = false, captcha_token, demo_source_user_id } = {}) => {
    const payload = { email, contact_consent }
    if (session_id) payload.session_id = session_id
    if (from_demo_account) payload.from_demo_account = true
    if (demo_source_user_id) payload.demo_source_user_id = demo_source_user_id
    if (captcha_token !== undefined) payload.captcha_token = captcha_token
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/magic-link', payload, {
        headers: DEFAULT_HEADERS,
        _suppressGlobalError: suppressGlobalError,
    })
}

export const setPasswordFromMagicLink = (token, new_password) => {
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/set-password', {
        token,
        new_password
    }, {
        headers: DEFAULT_HEADERS
    })
}

export const getDemoChatbots = () => {
    return http.get(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/onboarding/demo-chatbots', {
        headers: DEFAULT_HEADERS
    })
}

export const seenOnboarding = (utm_source, utm_medium, utm_campaign, utm_content, utm_term, utm_adgroup, utm_asset, utm_headline, utm_matchtype, utm_device, utm_placement, utm_adposition) => {
    return http.post(import.meta.env.VITE_APP_BASE_API + 'knowledge-bases/v2/onboarding/seen', {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        utm_adgroup,
        utm_asset,
        utm_headline,
        utm_matchtype,
        utm_device,
        utm_placement,
        utm_adposition
    }, {
        headers: DEFAULT_HEADERS
    })
}
